import { httpsCallable } from 'firebase/functions';
import { Lang } from '../contexts/locale.context';
import { functions } from '../firebase';

export type SmsProvider = 'google' | 'smsClub';
export const smsProvider: SmsProvider = 'google' as SmsProvider;

type SendSmsBySmsClubRequest = {
  phone: string;
  code: string;
  lang: Lang;
};

type SendSmsBySmsClubResponse = { data?: { status?: number } };

export const createConfirmRes = () => String(Math.random()).slice(2, 8);

export const sendSmsBySmsClub = httpsCallable(functions, 'sendSmsClub') as unknown as (
  req: SendSmsBySmsClubRequest
) => Promise<SendSmsBySmsClubResponse>;

export const encodeSms = (code: string): number => Number(code) * 248;
